import { ReactElement } from 'react';

import { Typography } from '@mui/material';
import { LogoIcon } from '@localstack/ui';

import { BaseLayout } from '~/layouts';
import { useAuthProvider } from '~/hooks/useAuthProvider';
import {
  MainContainer,
  ContentContainer,
  LogoContainer,
  InstructionsContainer,
  SubText,
  FooterContainer,
  EmailText,
} from '~/views/customer/Redirect/components';

/**
 * Handles authentication success page for auth request flow.
 * Shows a simple success message without any redirects.
 */
export const AuthRequestRedirect = (): ReactElement => {
  const { userInfo } = useAuthProvider();

  return (
    <BaseLayout title="LocalStack Authentication" hideNavigation>
      <MainContainer>
        <ContentContainer>
          <LogoContainer>
            <LogoIcon />
          </LogoContainer>
          <InstructionsContainer>
            <Typography textAlign="center" variant="h2" component="h1" fontWeight={600}>
              LocalStack is ready to use
            </Typography>
            <SubText>You can close this window.</SubText>
          </InstructionsContainer>
        </ContentContainer>
        <FooterContainer>
          <EmailText>Logged in as {userInfo?.user?.email}</EmailText>
        </FooterContainer>
      </MainContainer>
    </BaseLayout>
  );
};
